import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Modal from 'react-bootstrap/Modal';
import {Message, Button} from '@aperza/ui';
import { withTranslation } from 'react-i18next';
import {Constraint, ValidatorUtil} from '@aperza/validator';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import RelayService from '../../service/RelayService';
import EmailClipMutation from '../../mutation/EmailClipMutation';
import FormField from '../form/FormField';

class ClipEmailModal extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);
    console.log('ClipEmailModal constructor props', props)
    this.state = {
      email: '',
      invalidEmail: false,
    }
  };

  closeClipModal = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onEmailChange(e) {
    this.setState({
      email: e.target.value,
    })
  }

  onEmailFieldChange(fieldName, value) {
    this.setState({
      email: value,
    })
  }

  onClickSend() {
    if (ValidatorUtil.validateValue(this.state.email, Constraint.email)) {
      this.setState({
        invalidEmail: true,
      });
      return;
    }

    let args = {
      menuType: this.props.menuType,
      serviceId: this.props.serviceId,
      contentType: this.props.contentType,
      contentDetailType: this.props.contentDetailType,
      contentKey: this.props.contentKey,
      contentTitle: this.props.contentTitle,
      contentImageUrl: this.props.contentImageUrl,
      emailAddress: this.state.email,
    };

    return EmailClipMutation.commit(
      RelayService.environment,
      args,
      (response, error) => {
        console.log('EmailClipMutation response', response)
        if (this.props.onSuccess) {
          this.props.onSuccess();
        }
      },
    )
  }

  render() {
    const {itemPageShown, serviceId, t} = this.props;

    let messageText;
    if (itemPageShown === false) {
      messageText = serviceId == 3 ? "clip.email.info.2.product" : (serviceId == 5 ? "clip.email.info.2.catalog" : "clip.email.info.2.article");
    }
    else {
      messageText = "clip.email.info.2.catalog";
    }

    let {
      email,
      invalidEmail,
    } = this.state;

    return (
      <Modal
        show={this.props.open}
        onHide={::this.closeClipModal}
        size={'lg'}
        id="ClipEmailModal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Message messageId="clip.email.title"/>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><Message messageId={messageText}/></p>
          <Row>
            <Col lg={{ span: 6, offset: 3 }} xs={12}>
              <div className="mb-5">
                <Message className="font-weight-sbold fs-12 d-block mb-2" messageId="clip.email.info.3"/>
                <FormField fieldName={'email'}
                          value={email}
                          onChange={::this.onEmailFieldChange}
                          placeholderId={'clip.email.placeholder'}
                          errorId={'clip.email.invalid'}
                          invalid={invalidEmail}
                />
              </div>
              <div className="text-center mb-3">
                <Button size="xxxl"
                        wide={true}
                        id={'submitInquiryButton'}
                        type={Button.TYPE_PRIMARY}
                        onClick={::this.onClickSend}>
                  <Message messageId={'clip.send'}/>
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button size="xl" type={Button.TYPE_DEFAULT} wide={true} onClick={::this.closeClipModal}>{t('close')}</Button>
        </Modal.Footer>
      </Modal>
    )
  }

}

export default withTranslation()(ClipEmailModal)
